export const MetaData = {
  SELECT: "META_DATA_SELECT",
  UN_SELECT: "META_DATA_UN_SELECT",
  ASSIGN: "META_DATA_ASSIGN",
  RESET: "META_DATA_RESET",
};
